module.exports = "<div class=\"notifications-action\">\n  <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/quickstarts/quickstart-notifications/action/action.component.html
// module id = 1583
// module chunks = 2